export const formatPurgeDate = (val: unknown): string => {
  if (!val) {
    const d = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
    return d.toLocaleDateString()
  }
  if (typeof val === 'object' && val !== null) {
    if ('toDate' in val && typeof (val as { toDate: () => Date }).toDate === 'function') {
      return (val as { toDate: () => Date }).toDate().toLocaleDateString()
    }
    if ('_seconds' in val && typeof (val as { _seconds: number })._seconds === 'number') {
      return new Date((val as { _seconds: number })._seconds * 1000).toLocaleDateString()
    }
    if ('seconds' in val && typeof (val as { seconds: number }).seconds === 'number') {
      return new Date((val as { seconds: number }).seconds * 1000).toLocaleDateString()
    }
  }
  if (typeof val === 'number') {
    const ms = val < 10000000000 ? val * 1000 : val
    return new Date(ms).toLocaleDateString()
  }
  if (typeof val === 'string') {
    const d = new Date(val)
    if (!isNaN(d.getTime())) return d.toLocaleDateString()
  }
  const d = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  return d.toLocaleDateString()
}
